import React from 'react';
import PropTypes from 'prop-types';

// Wrap the component with forwardRef to handle refs properly
const TextFieldInput = React.forwardRef((props, ref) => {
  return <div ref={ref} {...props} />;
});

TextFieldInput.propTypes = {
  // You don’t need inputRef anymore because the ref is handled by forwardRef
};

export default React.memo(TextFieldInput);
